import "../stylesheets/header.css";

const Header = () => {
  return (
    <header>
      <h1>World Atlas</h1>
    </header>
  );
};

export default Header;
